import { render, staticRenderFns } from "./internalRTech.vue?vue&type=template&id=00bfcb5b&"
import script from "./internalRTech.vue?vue&type=script&lang=js&"
export * from "./internalRTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports